import React, { useState } from 'react';
import './Auth.css';

export default function Login({ onLogin, onForgot }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw]     = useState(false);
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const submit = async e => {
    e.preventDefault();
    if (!email || !password) { setError('Please fill in all fields'); return; }
    setLoading(true);
    setError('');
    const result = await onLogin({ email, password });
    setLoading(false);
    if (result && !result.ok) setError(result.error || 'Login failed');
  };

  return (
    <div className="auth-shell">
      <div className="auth-left">
        <div className="auth-container">
          <div className="login-card">
            <div className="auth-logo-wrap">
              <img src="/sidebar-logo.png" alt="TransferExpo" style={{height:'120px',width:'auto',maxWidth:'280px'}} />
            </div>
            <h1 className="login-title">Log In To Admin</h1>
            {error && <div className="auth-error-msg">{error}</div>}
            <form onSubmit={submit}>
              <div className="form-group">
                <input type="email" placeholder="Email Address"
                  value={email} onChange={e => setEmail(e.target.value)}
                  className="form-input form-control" required />
              </div>
              <div className="form-group">
                <div className="password-wrapper">
                  <input type={showPw ? 'text' : 'password'} placeholder="Enter Password"
                    value={password} onChange={e => setPassword(e.target.value)}
                    className="form-input password-input form-control" required />
                  <button type="button" className="password-toggle" onClick={() => setShowPw(v => !v)}>
                    {showPw
                      ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                      : <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 4C6 4 2.73 6.11 1 9.5C2.73 12.89 6 15 10 15C14 15 17.27 12.89 19 9.5C17.27 6.11 14 4 10 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 12.5C11.38 12.5 12.5 11.38 12.5 10C12.5 8.62 11.38 7.5 10 7.5C8.62 7.5 7.5 8.62 7.5 10C7.5 11.38 8.62 12.5 10 12.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><line x1="2" y1="2" x2="18" y2="18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                    }
                  </button>
                </div>
              </div>
              <div className="forgot-password-wrapper">
                <button type="button" className="forgot-password-link" onClick={onForgot}>Forgot Password?</button>
              </div>
              <button type="submit" className="custom-button" disabled={loading}>
                {loading ? 'Signing in...' : 'Log In'}
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="auth-right d-none d-lg-flex" style={{padding:'30px'}}>
        <div className="welcome-column">
          <div className="welcome-content">
            <h2>Welcome Back</h2>
            <p className="f-36">Please sign in to your admin account.</p>
            <img src="/login-bg.png" alt="Welcome" className="welcome-image" />
          </div>
        </div>
      </div>
    </div>
  );
}
